export const OPS_LOADING = "OPS_LOADING";
export const OPS_ERROR = "OPS_ERROR";
export const FETCH_CARRIERS = "FETCH_CARRIERS";
export const GET_STATUSES = "GET_STATUSES";
export const GET_CARRIER_STATUS_STATISTICS="GET_CARRIER_STATUS_STATISTICS";
export const GET_DRIVER_COUNT="GET_DRIVER_COUNT";